const calenderSeprator = '/calendar/separators';
export const getCalenderSeprator = calenderSeprator;
export const getCalenderSepratorById = (id: number) => `${calenderSeprator}/${id}?`;
export const createCalenderSeprator = calenderSeprator;
export const updateCalenderSeprator = (id: number) => `${calenderSeprator}/${id}`;

const eventCategory = '/calendar/events/categories';
export const getEventCategory = eventCategory;
export const getEventCategoryById = (id: number) => `${eventCategory}/${id}?`;
export const createEventCategory = eventCategory;
export const updateEventCategory = (id: number) => `${eventCategory}/${id}`;

const event = '/calendar/events';
export const getEvent = event;
export const getEventById = (id: number) => `${event}/${id}?`;
export const createEvent = event;
export const updateEvent = (id: number) => `${event}/${id}`;
